import React, { Component } from 'react';
import questions from '../../data/calcContent';
import getResults from '../../data/rqResults';
import FormPage from '../form/FormPage';
import Results from '../results/Results';
import QuizQuestion from './QuizQuestion';
import QuizAnswers from './QuizAnswers';
import QuizFooter from './QuizFooter';

export default class FullQuiz extends Component {
	constructor() {
		super();
		this.state = {
			currentQuestion: 0,
			answerValues: [],
			answerStrings: [],
			// incomeRange: '',
			displayQuiz: true,
			displayForm: false,
			displayResults: false,
			rqNumber: 0,
			rqResults: {}
		};
	}

	// Handles logic and animation for moving forwards and backwards
	incDecQuestion(incOrDec, inptFrmFooter = false) {
		// Ignores input from footer if current question isnt answered or if trying to go backwards on first question
		if (
			(!this.state.answerValues[this.state.currentQuestion] &&
				inptFrmFooter === true) ||
			(this.state.currentQuestion === 0 && incOrDec === 'dec')
		) {
			return;
		}
		// if inptFrmFooter = false then its incremented by system
		// OR if input from footer = true and an answer exists then transition
		if (
			(incOrDec === 'inc' && inptFrmFooter === false) ||
			(this.state.answerValues[this.state.currentQuestion] &&
				inptFrmFooter === true)
		) {
			this.handleAnimation('forward');
		}
		// animate going backwards
		if (incOrDec === 'dec') {
			this.handleAnimation('backward');
		}
		// TIMEOUT TO PREVENT QUESTION SWITCHING BEFORE TRANSITION ANIMATION
		// IF CHANGING TIME THEN ALSO ADJUST CSS TIME FOR 'movetonext' ANIMATION
		setTimeout(() => {
			// IF DECREMENTING: WILL allow unless you're on first question
			// IF INCREMENTING: WONT allow if current index in array is not filled
			this.setState(prevState => {
				return {
					currentQuestion:
						incOrDec === 'dec'
							? prevState.currentQuestion === 0
								? prevState.currentQuestion
								: prevState.currentQuestion - 1
							: this.state.answerValues[this.state.currentQuestion]
							? prevState.currentQuestion + 1
							: prevState.currentQuestion
				};
			});
		}, 510);
	}

	// determines whether transitioning forward or backwards
	handleAnimation(forwardOrBackward) {
		const questionWrapper = document.querySelector(
			'.question-section__wrapper'
		);
		questionWrapper.classList.add(`qs__${forwardOrBackward}`);
		questionWrapper.addEventListener('animationend', () => {
			questionWrapper.classList.remove(`qs__${forwardOrBackward}`);
		});
	}
	// Add's user selection to answerValues and answersStrings
	handleAnswer(addValue, addStrings) {
		// IF THIS IS THE LAST QUESTION THEN PUSH TO STATE AND TRIGGER FORM
		if (this.state.currentQuestion + 1 === questions.length) {
			this.setState(prevState => {
				return (prevState.answerStrings[this.state.currentQuestion] = addValue);
			});
			// Setting RQ number
			const rqNumber = Math.floor(
				this.state.answerValues.reduce((a, b) => a + b, 0) * 0.91
			);
			// Sends rqNumber to grab corresponding results
			const rqResults = getResults(rqNumber);

			return this.setState(prevState => ({
				rqNumber,
				rqResults,
				displayQuiz: !prevState.displayQuiz,
				displayForm: !prevState.displayForm
			}));
		}
		// Pushes current answer to state based on currentQuestion index
		this.setState(prevState => {
			return (
				(prevState.answerValues[this.state.currentQuestion] = addValue),
				(prevState.answerStrings[this.state.currentQuestion] = addStrings)
			);
		});
		// Auto increments after an answer
		this.incDecQuestion('inc');
	}
	// Makes the switch between the form and the results screen
	displayResults() {
		return this.setState(prevState => ({
			displayResults: !prevState.displayResults,
			displayForm: !prevState.displayForm
		}));
	}

	render() {
		let questionAsked = questions[this.state.currentQuestion].question;
		let answersArray = questions[this.state.currentQuestion].answers;
		return (
			<div>
				{this.state.displayQuiz && (
					<section className="question-section">
						<div className="question-section__wrapper">
							<QuizQuestion question={questionAsked} />
							<QuizAnswers
								onClick={(val, answer) => this.handleAnswer(val, answer)}
								answers={answersArray}
								prevAnswer={
									this.state.answerValues[this.state.currentQuestion]
										? this.state.answerValues[this.state.currentQuestion]
										: null
								}
							/>
						</div>
						<QuizFooter
							currentQuestion={this.state.currentQuestion}
							totalQuestions={questions.length}
							onClick={(incOrDec, input) =>
								this.incDecQuestion(incOrDec, input)
							}
						/>
					</section>
				)}
				{this.state.displayForm && (
					<FormPage
						rqNumber={this.state.rqNumber}
						answerValues={this.state.answerValues}
						income={this.state.answerStrings[11]}
						onClick={() => this.displayResults()}
						title={this.state.rqResults.title || ''}
					/>
				)}
				{this.state.displayResults && (
					<Results
						title={this.state.rqResults.title}
						score={this.state.rqNumber}
						explanation={this.state.rqResults.explanation}
						picRef={this.state.rqResults.picRef}
						rqDetail={this.state.rqResults.rqDetail}
						disclaimer1={this.state.rqResults.disclaimer1}
						disclaimer2={this.state.rqResults.disclaimer2}
					/>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/quiz/Quiz.js